import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { type LightInvoiceDto } from "@modules/finances/gateway/lightInvoiceDto"

export class LightInvoiceEntity {
  price: PriceObjectEntity
  invoiceDate: Date

  private constructor(price: PriceObjectEntity, invoiceDate: Date) {
    this.price = price
    this.invoiceDate = new Date(invoiceDate)
  }

  static fromDto(dto: LightInvoiceDto): LightInvoiceEntity {
    return new LightInvoiceEntity(PriceObjectEntity.fromDto(dto.price), new Date(dto.invoiceDate))
  }

  static toDto(entity: LightInvoiceEntity): LightInvoiceDto {
    return {
      price: PriceObjectEntity.toDto(entity.price),
      invoiceDate: entity.invoiceDate.toISOString(),
    }
  }
}
